/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleConstraintEntity } from './ScheduleConstraintEntity';
import {
    ScheduleConstraintEntityFromJSON,
    ScheduleConstraintEntityFromJSONTyped,
    ScheduleConstraintEntityToJSON,
    ScheduleConstraintEntityToJSONTyped,
} from './ScheduleConstraintEntity';
import type { ScheduleParticipantEntity } from './ScheduleParticipantEntity';
import {
    ScheduleParticipantEntityFromJSON,
    ScheduleParticipantEntityFromJSONTyped,
    ScheduleParticipantEntityToJSON,
    ScheduleParticipantEntityToJSONTyped,
} from './ScheduleParticipantEntity';
import type { ScheduleBlockEntity } from './ScheduleBlockEntity';
import {
    ScheduleBlockEntityFromJSON,
    ScheduleBlockEntityFromJSONTyped,
    ScheduleBlockEntityToJSON,
    ScheduleBlockEntityToJSONTyped,
} from './ScheduleBlockEntity';

/**
 * 
 * @export
 * @interface ScheduleEntity
 */
export interface ScheduleEntity {
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    scheduleType?: ScheduleEntityScheduleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    timezone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleEntity
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleEntity
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleEntity
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    recurrencePattern?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    metadata?: string;
    /**
     * 
     * @type {Array<ScheduleParticipantEntity>}
     * @memberof ScheduleEntity
     */
    participants?: Array<ScheduleParticipantEntity>;
    /**
     * 
     * @type {Array<ScheduleBlockEntity>}
     * @memberof ScheduleEntity
     */
    scheduleBlocks?: Array<ScheduleBlockEntity>;
    /**
     * 
     * @type {Array<ScheduleConstraintEntity>}
     * @memberof ScheduleEntity
     */
    constraints?: Array<ScheduleConstraintEntity>;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleEntity
     */
    timeZone?: string;
}


/**
 * @export
 */
export const ScheduleEntityScheduleTypeEnum = {
    OnCall: 'ON_CALL',
    Job: 'JOB',
    Task: 'TASK',
    Contact: 'CONTACT',
    Custom: 'CUSTOM'
} as const;
export type ScheduleEntityScheduleTypeEnum = typeof ScheduleEntityScheduleTypeEnum[keyof typeof ScheduleEntityScheduleTypeEnum];


/**
 * Check if a given object implements the ScheduleEntity interface.
 */
export function instanceOfScheduleEntity(value: object): value is ScheduleEntity {
    return true;
}

export function ScheduleEntityFromJSON(json: any): ScheduleEntity {
    return ScheduleEntityFromJSONTyped(json, false);
}

export function ScheduleEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'scheduleType': json['scheduleType'] == null ? undefined : json['scheduleType'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'active': json['active'] == null ? undefined : json['active'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'recurrencePattern': json['recurrencePattern'] == null ? undefined : json['recurrencePattern'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'participants': json['participants'] == null ? undefined : ((json['participants'] as Array<any>).map(ScheduleParticipantEntityFromJSON)),
        'scheduleBlocks': json['scheduleBlocks'] == null ? undefined : ((json['scheduleBlocks'] as Array<any>).map(ScheduleBlockEntityFromJSON)),
        'constraints': json['constraints'] == null ? undefined : ((json['constraints'] as Array<any>).map(ScheduleConstraintEntityFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}

export function ScheduleEntityToJSON(json: any): ScheduleEntity {
    return ScheduleEntityToJSONTyped(json, false);
}

export function ScheduleEntityToJSONTyped(value?: ScheduleEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'description': value['description'],
        'scheduleType': value['scheduleType'],
        'timezone': value['timezone'],
        'active': value['active'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'recurrencePattern': value['recurrencePattern'],
        'metadata': value['metadata'],
        'participants': value['participants'] == null ? undefined : ((value['participants'] as Array<any>).map(ScheduleParticipantEntityToJSON)),
        'scheduleBlocks': value['scheduleBlocks'] == null ? undefined : ((value['scheduleBlocks'] as Array<any>).map(ScheduleBlockEntityToJSON)),
        'constraints': value['constraints'] == null ? undefined : ((value['constraints'] as Array<any>).map(ScheduleConstraintEntityToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'timeZone': value['timeZone'],
    };
}

